import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiUrl } from "features/configure";
import Box from "@mui/material/Box";
import DappActivityTrackingSettingContent from "./DappActivityTrackingSettingContent";
import { Button, SIZE } from "@metacrm/metacrm-material-ui/dist/Button";
import { useTheme } from "@mui/styles";
import { useOutletContext, useNavigate } from "react-router-dom";
import { parseCustomDomainUrl } from "features/helpers/utils";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { get, isEmpty } from "lodash-es";

import { useIntl } from "react-intl";
import useAnalyticsModule from "hooks/useAnalyticsModule";
import { useOpenState } from "contexts/stepContext/Open.context";
import useGetPagePermission from "hooks/useGetPagePermission";

const DappActivityTracking = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const navigate = useNavigate();
  const { setOpen } = useOpenState();
  const [entityName, isCustomDomain] = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const dispatchSnackbar = useDispatchSnackbar();
  // const { attributionConnect } = useAnalyticsModule(); TODO 是否要判斷attributionConnect

  async function getObjectiveList() {
    try {
      setLoading(true);
      const { data } = await axios.get(
        apiUrl + `/api/dAppTracking/${entityName}/contracts`
      );
      setDataList(get(data, "contracts", []));
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setLoading(false);
    }
  }

  const pagePermission = useGetPagePermission();
  const { canEdit } = pagePermission("webTraffic");

  useEffect(() => {
    getObjectiveList();
  }, []);

  const handleToCreateObjective = (targetId, row) => {
    // if (!isEmpty(dataList)) {
    //   return setOpen({ upgrade: true });
    // }
    navigate(
      parseCustomDomainUrl(
        isCustomDomain,
        entityName,
        `/analytics/settings/dapp-activity-tracking/add-contract`
      )
    );
  };

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        mb="24px"
        className="fade-up"
      >
        <Box>
          <Box className={"title"}>
            {formatMessage({
              id: "dAppTracking.settings.title",
            })}
          </Box>
          <Box
            sx={{
              fontSize: "14px",
              color: theme.customColors.grey[600],
              marginTop: "12px",
            }}
          >
            {formatMessage({
              id: "dAppTracking.settings.description",
            })}
          </Box>
        </Box>
        <Box>
          <Button
            onClick={handleToCreateObjective}
            disabled={dataList.length > 0}
            size={SIZE.MEDIUM}
            sx={{
              width: "80px",
            }}
          >
            {formatMessage({ id: "global.btn.add" })}
          </Button>
        </Box>
      </Box>
      <Box className="fade-up-more">
        <DappActivityTrackingSettingContent
          dataList={dataList}
          loading={loading}
          // onDelete={handleDelete}
        ></DappActivityTrackingSettingContent>
      </Box>
    </>
  );
};

export default DappActivityTracking;
